module.exports = __webpack_public_path__ + "static/sf-ui-medium-c520bec39f4f37f3034397e65bbed457.woff";